/* This component is header component which is reusable 
   for all components 
   Created by: Nikhil Gaykhe
*/

import React, { useEffect, useState } from 'react';
import SideNav from 'NOTICEBOARD/Header/SideNavigation/SideNav';
import 'NOTICEBOARD/Header/header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import NoticeboardAPICall from 'NoticeboardAPICall';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import UserActivityPanel from 'NOTICEBOARD/CommonResources/UserActivityPanel/UserActivityPanel'
import NotificationPanel from 'NOTICEBOARD/CommonResources/NotificationPanel/NotificationPanel';


const Header = (props) => {
    const pointsData = config.pointsInfo;
    
    // VARIABLES FOR OVERDUE MESSAGE
    const [overdueCondition, setOverdueCondition] = useState('');
    const [overdueMessage, setOverdueMessage] = useState('');
    const [stepNumber, setStepNumber] = useState('');
    const [alertModal, setAlertModal] = useState(false);
    const [dueDate, setDueDate] = useState("");
    const [dateAfterSevenDays, setDateAfterSevenDays] = useState("");
    const [paymentAcceptanceObject, setPaymentAcceptanceObject] = useState({});
    const [acceptanceSequenceIdArray, setAcceptanceSequenceIdArray] = useState([]);
    const [clientSubscriptionId, setClientSubscriptionId] = useState('');
    const [installmentId, setInstallmentId] = useState('');
    const [acceptanceCount, setAcceptanceCount] = useState('');
    const [showModuleDetails, setShowModuleDetails] = useState(false);
    const [daysCount, setDaysCount] = useState("seven");
    const [acceptingExtension, setAcceptingExtension] = useState(false);

    // VARIABLES TO VIEW MODULE LIST POPOVER
    const [showFilter, setShowFilter] = useState(false);
    const [moduleListArray, setModuleListArray] = useState([]);
    const [searchModule, setSearchModule] = useState('');
    const [checkedValue, setCheckedValue] = useState([]);
    const [temporaryModuleListArray, setTemporaryModuleListArray] = useState([]);

    // VARIABLES TO VIEW SUCCESS MODAL
    const [successModal, setSuccessModal] = useState(false);
    const [successModalType, setSuccessModalType] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [ActivityLogModal, setActivityLogModal] = useState(false);
    const [moduleListModal, setModuleListModal] = useState(false);
    const [userInfoModal, setUserInfoModal] = useState(false);
    const [notificationModal, setNotificationModal] = useState(false);
    
    //GET TEMPLATE DATA
    const routingMenu = useSelector((state) => state.RouteMenuReducer);

    const dispatch = useDispatch();

    const imageExtensions = ['jpeg', 'jpg', 'png'];

    useEffect(() => {
        document.getElementById("mySidenav").style.width = "0";
        
        if(config.instructorInfo.account == 'faculty') {
            //API CALL TO GET MODULE LIST ARRAY
            Axios.get(`${config.RootUrl}/faculty/summary/moduleNavigation.json`).then(res => {
                setModuleListArray(res.data);
                setTemporaryModuleListArray(res.data);
            });
        }else {
            //API CALL TO GET MODULE LIST ARRAY
            Axios.get(`${config.RootUrl}/student/learnerModuleNavigation.json`).then(res => {
                setModuleListArray(res.data);
                setTemporaryModuleListArray(res.data);
            });
        }
        
        // METHOD CALLED TO GET OVERDUE
        apiCallToGetOverdueDetails();
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === ' ') 
            {
                handleModalOpenClose('moduleList')
            }

            if (event.key === 'Escape') {
                handleEscapeKey();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    // API CALL METHOD TO GET OVERDUE DETAILS
    const apiCallToGetOverdueDetails = async () => {
        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'GetHelpDeskPendingInstallmentDueDateMessage',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetOverdueDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let alertModal = false;
                let stepNumber = jsonResponse.APIResult.stepNumber;
            
                if(!(stepNumber ==0 && apiResult.acceptanceSequenceIdArray.length == 0)) {
                    document.getElementById("routeSetup").style.paddingTop = "76px";
                }else {
                    document.getElementById("routeSetup").style.paddingTop = "50px";
                }
            
                if(stepNumber>3 ) {
                    alertModal = true;
                }

                if((stepNumber == 4 && apiResult.acceptanceSequenceIdArray.length == 1) || (stepNumber == 5 && apiResult.acceptanceSequenceIdArray.length == 2) || (stepNumber == 6 && apiResult.acceptanceSequenceIdArray.length == 3)) {
                    alertModal= false;
                }
                
                let acceptanceCount = apiResult.acceptanceSequenceIdArray.length + 1;

                setOverdueCondition(apiResult.status);
                setOverdueMessage(apiResult.message);
                setDueDate(apiResult.dueDate);
                setDateAfterSevenDays(apiResult.dateAfterSevenDays);
                setPaymentAcceptanceObject(apiResult.paymentAcceptanceObj);
                setAcceptanceSequenceIdArray(apiResult.acceptanceSequenceIdArray);
                setClientSubscriptionId(apiResult.clientSubscriptionId);
                setDaysCount(apiResult.daysCount);
                setInstallmentId(apiResult.installmentId);
                setStepNumber(stepNumber);
                setAlertModal(alertModal);
                setAcceptanceCount(acceptanceCount);
            }
        }
    }

    //METHOD TO ACCEPT SUBSCRIPTION EXTENSION
    const apiCallToAcceptExtension = async () =>{
        setAcceptingExtension(true);
        
        let acceptanceCount = acceptanceSequenceIdArray.length + 1;

        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "clientSubscriptionId": clientSubscriptionId,
            "installmentId": installmentId,
            "acceptanceCount": acceptanceCount,
            "dueDate": dueDate,
            "dateAfterSevenDays": dateAfterSevenDays,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'AddHelpDeskInstallmentAcceptanceDetails',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToAcceptExtension();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                
                setAcceptingExtension(false);

                if(apiResult.status == "success") {
                    setAlertModal(false);
                    setAcceptanceCount(acceptanceCount);
                    setShowModuleDetails(true);
                    setSuccessModal(true);
                    setSuccessModalType('success');
                    setSuccessMessage(apiResult.message);
                }
            }
        }
    }

    // METHOD TO RETURN SUCCESS MODAL FOR TRANSITION / TRANSFER QUERY
    const returnSubscriptionAlertModal = () => {
        return(
            <div className={alertModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">                        
                        <div className="modal-body SubscriptionAlertModal-body">
                            <div style={{display:"flex",flexDirection:"column-reverse",alignItems:"flex-end"}} className="col-md-12">
                                <a className="" style={{ cursor: 'pointer' }} href = {`${config.RootUrl}/vmlogout.php?url=${config.instructorInfo.InstituteUrl}`} onClick={() => userSignOut()}>
                                    Log Out
                                </a>
                            </div>
                            {
                                stepNumber == 3 ? 
                                    <div className="step3">
                                        <div className="col-md-10">
                                            <div>Dear Sir/Madam,</div>
                                            <div>Greetings from vmedulife!</div>
                                            <br/>                                       
                                            <div>This is a formal reminder for your <span style={{backgroundColor:'yellow'}}>upcoming installment payment due on </span> </div>
                                            <div style={{fontWeight:"bold"}}>{dueDate}.</div>
                                            <br/>                                       
                                            <div>Please provide the confirmation for the payment to avoid subscription expiry.</div>
                                            <br/>
                                            <div >Regards,</div>
                                            <div>Team vmedulife</div>
                                        </div>
                                        <div className="col-md-2 ">
                                            <div className="warningIconContainer">
                                                <FontAwesomeIcon  className="warningicon" icon={['fas', 'exclamation-triangle']}  size="lg" color="#F44336" />
                                            </div>
                                        </div>
                                    </div>
                                :
                                stepNumber == 4 ? 
                                    <div className="step4">
                                        <div className="col-md-10">
                                            <div>Dear Sir/Madam,</div>
                                            <div>Greetings from vmedulife!</div>
                                            <br/>                                     
                                            <div>This is a to inform you that your subscription payment was due on </div>
                                            <div style={{fontWeight:"bold"}}>{dueDate}.</div>
                                            <br/>
                                            <div>Please provide the acceptance that you will be clearing the pending dues in next {daysCount} days by <span style={{fontWeight:"bold"}}>{dateAfterSevenDays}.</span></div>
                                            <br/>
                                            <div>Your acceptance will be highly appreciable and respective stakeholders of the institute will be receiving an email confirmation once you click on the below <span style={{color:'green'}}>'Accept'</span> button.</div>
                                            <br/>
                                            <div >Regards,</div>
                                            <div>Team vmedulife</div>
                                        </div>
                                        <div className="col-md-2 ">
                                            <div className="warningIconContainer">
                                                <FontAwesomeIcon  className="warningicon" icon={['fas', 'exclamation-triangle']}  size="lg" color="#F44336" />
                                            </div>
                                        </div>
                                    </div>
                                :
                                (stepNumber == 5 || stepNumber == 6) ? 
                                    <div className="step5">
                                        <div className="col-md-10">
                                            <div>Dear Sir/Madam,</div>
                                            <div>Greetings from vmedulife!</div>
                                            <br/>                                     
                                            <div>This is a to inform you that your subscription payment was due on </div>
                                            <div style={{fontWeight:"bold"}}>{dueDate}.</div>
                                            <br/>
                                            <div>Please provide the acceptance that you will be clearing the pending dues in next {daysCount} days by <span style={{fontWeight:"bold"}}>{dateAfterSevenDays}.</span></div>
                                            <br/>
                                            <div>Your acceptance will be highly appreciable and respective stakeholders of the institute will be receiving an email confirmation once you click on the below <span style={{color:'green'}}>'Accept'</span> button.</div>
                                            <br/>   
                                        </div>
                                        <div className="col-md-2 ">
                                            <div className="warningIconContainer">
                                                <FontAwesomeIcon  className="warningicon" icon={['fas', 'exclamation-triangle']}  size="lg" color="#F44336" />
                                            </div>
                                        </div>
                                    </div>
                                :
                                    <div className="step5">
                                        <div className="col-md-10">
                                            <div>Dear Sir/Madam,</div>
                                            <div>Greetings from vmedulife!</div>
                                            <br/>                                     
                                            <div>This is a to inform you that your subscription payment was due on </div>
                                            <div style={{fontWeight:"bold"}}>{dueDate}.</div>
                                            <br/>                                        
                                        </div>
                                        <div className="col-md-2 ">
                                            <div className="warningIconContainer">
                                                <FontAwesomeIcon  className="warningicon" icon={['fas', 'exclamation-triangle']}  size="lg" color="#F44336" />
                                            </div>
                                        </div>
                                    </div>
                            }     
                            <div className="lastAcceptedUserList">
                            {
                                acceptanceSequenceIdArray.map((acceptanceId,index) => {
                                    let acceptance = paymentAcceptanceObject[acceptanceId];
                                    return(
                                        <div className="lastAcceptedUserCard">
                                            <FontAwesomeIcon  className="userIconSubscription" icon={['fas', 'user']} style={{marginRight:5}} size="lg" color="gray" />
                                            Payment Date Extension Confirmed By: <span style={{fontWeight:'bold',color:'gray'}}>{acceptance.acceptedByName} | {acceptance.acceptedOn}</span>
                                        </div>
                                    )
                                })
                            }
                            </div>                      
                            {
                                stepNumber == 3 ?
                                    <div style={{display:'flex',flexDirection:'row-reverse'}}>
                                        <button className="btn outline-button backQueryButton" style={{ textTransform: 'none',cursor:'Pointer' }} onClick={() => setAlertModal(false)}>
                                            Close
                                        </button>
                                    </div>
                                :
                                (stepNumber == 4 || stepNumber == 5 || stepNumber == 6) &&
                                    <div style={{display:'flex',flexDirection:'row-reverse'}}>                                   
                                        <button className="btn acceptButton" style={{ textTransform: 'none' }} onClick={() => apiCallToAcceptExtension()} disabled={acceptingExtension}>
                                            I, Accept
                                        </button>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // HANDLE FILTER BY CATEGORY
    const handleFilterByCategory = (e) => {
        let checkedValues = checkedValue;

        if (checkedValues.includes(e.target.value)) {
            checkedValues = checkedValues.filter(name => name != e.target.value);
        }else {
            checkedValues.push(e.target.value);
        }

        setCheckedValue(checkedValues);
        
        handleFilterByCategoryResponse(checkedValues);
    }

    // HANDLE FILTER BY CATEGORY RESPONSE
    const handleFilterByCategoryResponse = (checkedValues) => {
        let checkedFilterArray = [];
        
        temporaryModuleListArray.map((module_type) => {
            let isChecked = false;
            for (let i = 0; i < checkedValues.length; i++) {
                if (module_type.moduleType.includes(checkedValues[i])) {
                    isChecked = true;
                }
            }

            if (isChecked) {
                checkedFilterArray.push(module_type);
            }
        });

        if (checkedValues.length == 0) {
            setModuleListArray(temporaryModuleListArray);
        } else {
            setModuleListArray(checkedFilterArray);
        }
    }

    // METHOD TO OPEN SIDE NAVIGATION MENU
    const openNav = () => {
        document.getElementById("mySidenav").style.width = "350px";
    }

    const userSignOut = () => {
        props.history.push(`${config.RootUrl}/vmlogout.php`);
    }

    if (config.institute_name === '' || config.institute_name === undefined) {
        config.institute_name = 'vmedulife';
    }
    //handleModalOpenClose
    const handleModalOpenClose = (modalName) => {

        if (modalName == "moduleList") 
        {
            setModuleListModal(!moduleListModal);
            setUserInfoModal(false);    
            setActivityLogModal(false);
            setNotificationModal(false);
        }
        if (modalName == "userInfo") {
            setUserInfoModal(!userInfoModal);
            setModuleListModal(false);
            setActivityLogModal(false);
            setNotificationModal(false);

        }
        if (modalName == "notification") {
            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(false);
            setNotificationModal(!notificationModal);

        }
        if (modalName == "userActivity") {
            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(!ActivityLogModal);
            setNotificationModal(false);

        }
    }

    const handleEscapeKey = () => {
        setModuleListModal(false);
        setUserInfoModal(false);
        setActivityLogModal(false);
        setNotificationModal(false);
    }

    
    return (
        <>
            <div id = "header">
                <nav className="navbar navbar-expand-lg navbar-dark">
                <div className="college-name">
                        <button className="sidenav-button btn btn-link text-white" style={{ fontSize: 16 }} type="button" onClick={(e) => config.account == 'faculty' ? (routingMenu.isSideMenuNavigation ? openNav() : (routingMenu.expandRouteMenu ? dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: false }) : dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: true }))) : openNav()}>
                            <FontAwesomeIcon icon={['fas', 'bars']} size="lg" style={{ fontSize: 20 }} />
                        </button>
                        <a href={config.account == "faculty" ? config.RootUrl + '/modules/summary/#/' : config.RootUrl + '/student/Summary.php'}>
                            <p className="college text-white">{ReactHtmlParser(config.institute_name)}</p>
                        </a>
                    </div>
                    <div className="user-info">
                        {
                            config.account != "student" &&  <UserActivityPanel ActivityLogModal={ActivityLogModal} handleModalOpenClose={handleModalOpenClose} />
                        }
                        <NotificationPanel notificationModal={notificationModal} handleModalOpenClose={handleModalOpenClose} />
                        {
                            config.account != "student" &&  
                            <span className="dropdown mr-4">
                                <FontAwesomeIcon style={{ color: 'white', marginLeft: 10, cursor:'pointer', fontSize: 18 }} size="xl" icon={['fas', 'th']} data-toggle="dropdown" />
                                <div class={`dropDownDiv dropdown-menu userDetailsMenu mt-2 ${moduleListModal ? 'show' : ''}`} id="moduleDropdown" aria-labelledby="dropdownMenuButton" style={{ left: '-57vw', width: '60vw', borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px' }} >
                                    <div className='row col-md-12 d-flex flex-column'>
                                        <div className='col-md-12 moduleListHeaderDetails row' style={{ padding: 0 }}>
                                            <div className='col-md-4' style={{ padding: 0 }}>
                                                <h4>Modules</h4>
                                            </div>
                                            <div className='col-md-6 mblScreen align-items-center' style={{ padding: 0 }}>
                                                <input
                                                    className="form-control mr-sm-2 searchModuleInput"
                                                    type="search"
                                                    placeholder="Search"
                                                    aria-label="Search"
                                                    onChange={(e) => setSearchModule(e.target.value.toLowerCase())}
                                                />
                                                {
                                                    config.account == 'faculty' &&
                                                        <span className="dropdown">
                                                            <p className="filterModuleButton" data-toggle="dropdown" style={{ marginBottom: 0 }} onClick={() => setShowFilter(!showFilter)}>
                                                                <FontAwesomeIcon icon={['fas', 'filter']} style={{ marginRight: 5 }} />
                                                                Filter
                                                            </p>
                                                            <div className={showFilter ? "dropDownFilter dropdown-menu moduleTypeMenu show" : " dropdown-menu deleteMenu"} style={{ left: '-31vh', borderRadius: 5 }} aria-labelledby="dropdownMenuButton" onClick={(e) => e.stopPropagation()}>
                                                                <span className="dropdown-item d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                                    <input
                                                                        className='mr-2'
                                                                        type="checkbox"
                                                                        onChange={(e) => handleFilterByCategory(e)}
                                                                        value="OBE (Outcome Based Education)"
                                                                        id="0"
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                                    <p className='filterName' style={{ marginBottom: 0 }}> OBE (Outcome Based Education)</p>
                                                                </span>
                                                                <span className="dropdown-item d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                                    <input
                                                                        className='mr-2'
                                                                        type="checkbox"
                                                                        onChange={(e) => handleFilterByCategory(e)}
                                                                        value="ERP (Enterprise Resource Planning)"
                                                                        id="1"
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                                    <p className='filterName' style={{ marginBottom: 0 }}> ERP (Enterprise Resource Planning)</p>
                                                                </span>
                                                                <span className="dropdown-item d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                                    <input
                                                                        className='mr-2'
                                                                        type="checkbox"
                                                                        onChange={(e) => handleFilterByCategory(e)}
                                                                        value="Teaching & Learning"
                                                                        id="2"
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                                    <p className='filterName' style={{ marginBottom: 0 }}> Teaching & Learning</p>
                                                                </span>
                                                            </div>
                                                        </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="dropdown-divider"></div>
                                        <div className='row customScrollDiv' style={{ maxHeight: '46vh', overflowY: 'scroll' }} >
                                            {
                                                moduleListArray.filter((moduleName) =>
                                                    moduleName.title.toLowerCase().includes(searchModule)).length == 0 ?
                                                        <p style={{ fontSize: 14, color: '#818181' }}>Any result is not available as per your applied filter. Please alter your selection text.</p>
                                                    :
                                                    moduleListArray.filter((moduleName) =>
                                                            moduleName.title.toLowerCase().includes(searchModule)).map((item) => {
                                                                return (
                                                                    <a className='moduleItems col-md-4 col-sm-12' href={`${config.RootUrl}${item.url}`} underline="none">
                                                                        <div className='moduleListIcon'>
                                                                            <FontAwesomeIcon href={`${config.RootUrl}${item.url}`} icon={[`${item.iconType}`, `${item.iconName}`]} />
                                                                        </div>
                                                                        <b className='menuText titleName'>{item.title}</b>
                                                                    </a>

                                                                )
                                                            })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </span>
                        }
                        <span className="award-points">
                            <span className="awards badge-pill" style={{ display: "inline-flex", paddingTop: 0, alignItems: "center" }}>
                                {pointsData}<FontAwesomeIcon className="award-icon" icon={['fas', 'trophy']} size="lg" color="#FF9900" />
                            </span>
                        </span>
                        <div className="streams-user-info">
                            <span className="dropdown mr-4">
                                {
                                    imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
                                        <img src={config.userPic} className="admin" data-toggle="dropdown" style={{ cursor: 'pointer' }} />
                                    :
                                        <FontAwesomeIcon
                                            icon={['fas', 'user-circle']}
                                            size="lg"
                                            style={{ fontSize: 30, cursor: 'pointer' }}
                                            color="#fff"
                                            data-toggle="dropdown"
                                        />
                                }
                                <div class="dropDownDiv dropdown-menu userDetailsMenu mt-2" id="moduleDropdown" aria-labelledby="dropdownMenuButton" onClick={(e) => e.stopPropagation()} style={{ left: '-17vw', width: '20vw', borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px' }} >
                                    <div className="userName-Image">
                                        {
                                            imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
                                                <img src={config.userPic} className="admin" data-toggle="dropdown" />
                                            :
                                                <FontAwesomeIcon
                                                    icon={['fas', 'user-circle']}
                                                    size="lg"
                                                    style={{ fontSize: 30 }}
                                                    color="#000"
                                                    data-toggle="dropdown"
                                                />
                                        }
                                        <p style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 0 }}>{config.instructorInfo.FirstName} {config.instructorInfo.LastName}</p>
                                    </div>
                                    <hr />
                                    <div className="userEmailId">
                                        <FontAwesomeIcon icon={['far', 'envelope']} style={{ width: 20, fontSize: 18 }} />
                                        <p style={{ fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', marginBottom: 0 }} title={config.emailId}>{config.emailId}</p>
                                    </div>
                                    <div className="userAccessId">
                                        <FontAwesomeIcon icon={['far', 'id-badge']} style={{ width: 20, fontSize: 18 }} />
                                        <p style={{ fontSize: 14, marginBottom: 0 }}>{config.instructorInfo.user_id}</p>
                                    </div>
                                    <hr />
                                    <div className="updateProfileContainer">
                                        <a className="updateProfileLink" href={config.account == 'faculty' ? config.RootUrl + "/faculty/Personalize.php" : config.RootUrl + "/student/Personalize.php"}>
                                            <p className="updateProfileButton" title="Click to update profile details" style={{ marginBottom: 0 }}>
                                                Update Profile
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </span>
                            <a href={`${config.RootUrl}/vmlogout.php?url=${config.instructorInfo.InstituteUrl}`} className="signout" onClick={() => userSignOut()}>
                                <FontAwesomeIcon className="signout-icon icon" icon={['fas', 'power-off']} size="lg" />Sign Out
                            </a>
                        </div>
                    </div>
                </nav>
            </div>
            <div className = "subscriptionStrip" style={{ backgroundColor: (stepNumber > 1 || acceptanceCount > 1) ? '#EB5757' : stepNumber == 1 ? '#FF7800' : 'transparent', paddingTop: !(stepNumber >= 1 || acceptanceCount > 1)  ? 50 : 5, paddingBottom: !(stepNumber >= 1 || acceptanceCount > 1) ? 0 : 2, height: !(stepNumber >= 1 || acceptanceCount > 1) ? 0 : 'auto', zIndex: !(stepNumber >= 1 || acceptanceCount > 1) ? -1 : 19 }}>{overdueMessage}</div>
            <SideNav />
            {
                returnSubscriptionAlertModal()
            }
            {
                successModal &&
                    <SuccessModal 
                        successModal={successModal} 
                        successModalType={successModalType}
                        successMessage={successMessage}
                        closeSuccessModal={setSuccessModal(false)} 
                    />
            }
        </>
    );
}

export default Header;